module.exports = __webpack_public_path__ + "img/ng_logo2.1123390f.svg";